module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-e5ce66c5.png";